import React from "react";
import { useSelector } from "react-redux";
import DashedBorder from "@default/general-components/dashed-border";
import Link from "../general-components/link/link";

const MenuCtaNav = () => {
  const fieldMenuCta = useSelector(
    (state) => state.appStore.mainSettings?.fieldMenuCta
  );

  if (!fieldMenuCta) return null;

  return (
    <div className="menu-cta-nav navigation-element">
      <DashedBorder blurredBackdrop reverse />
      <Link className="headline-s" link={fieldMenuCta} />
    </div>
  );
};

export default MenuCtaNav;
